module.exports = __webpack_public_path__ + "img/cmbs-img.cc70ae6c.png";